function formatCurrency(number) {
    if (number < 1000) return number;
    return (number / 1000).toFixed(3);
}

async function checkStock(productId) {
  const data = await fetch('https://stock-api.nint.hu/' + productId)
  const res = await data.json()

  if (!res || res.error) {
    return
  }

  if(!res.quantity || res.quantity === 0) {
      const btn = document.getElementById('ProductSubmitButton-template--21603510518098__main')

      btn.disabled = true
      document.querySelector('#ProductSubmitButton-template--21603510518098__main > span').textContent = 'Elfogyott'
  }

  if (!res.price) return;

  const sale = document.getElementsByClassName('price-item price-item--sale price-item--last')[0];
  const saleVisible = sale.checkVisibility()

  if(saleVisible) {
    sale.textContent = `${formatCurrency(res.price)} Ft`
    return
  }
  
  document.getElementsByClassName('price-item price-item--regular')[0].textContent = `${formatCurrency(res.price)} Ft`
}